module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "introductiontitle"
  }, [_c('a', {
    attrs: {
      "id": "frontmatter02"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "introductiontitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OUTSOURCING: OPPORTUNITIES AND CHALLENGES")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Outsourcing is a growing phenomenon, but it’s something that we should realize is probably a plus for the economy in the long run. It’s just a new way of doing international trade.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphsource"
  }, [_vm._v("—Gregory Mankiw, chairman of the White House Council of Economic Advisors, 2004 Economic Report of the President"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Perhaps like many businesspeople around the world, you’re seeking silver-lining solutions to both the opportunities and challenges created by outsourcing, a crucial but admittedly difficult-to-implement business innovation. But as you know, silver linings can be very hard to find. Therefore, our objective in this book is to help with that effort, specifically, to give you a “silver-lining perspective” on outsourcing, by which we mean more than just a bright spot amidst the political and emotional storm clouds of controversy. Generations before us have adapted to revolutionary innovations in technology and business efficiency and we will, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We intend to guide you in your personal, corporate, and strategic efforts to take advantage of the opportunities, as well as meet the challenges, of outsourcing, whether you’re a corporate manager responsible for an outsourcing initiative; an outsourcing job seeker; an entrepreneur, venture capitalist, or small business owner investigating the bottom-line benefits of this practice. By virtue of the fact that you’re reading this book, you’re among those who will lead the rest in powerful global economic change.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One of the reasons the silver linings of outsourcing remain so elusive is that, despite its growing status as a mainstream business activity, it remains underresearched and poorly understood. There is a shortage of reliable information on outsourcing and business process outsourcing (BPO) markets, vendors and their capabilities, needs of different vertical segments, costs and capability benchmarking of service providers, location evaluation and assessment . . . and so on. Sadly, due to this dearth of good information, many companies are making serious mistakes. For example, all too often an outsourcing relationship is initiated without an evaluation of market alternatives, which can easily lead to a higher price. We’re here to help you avoid this and other mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As industry becomes more comfortable with the shift in the globalization model toward offshore outsourcing, corporate outsource-buying professionals are charged with the task of being good stewards of their company’s resources. This book provides these professionals with a step-by-step guide to the outsourcing process, along with abundant contact information for leading outsourcing firms and career opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Outsourcing can be a complicated undertaking, for management, job seekers, and entrepreneurs alike, as revealed in a survey of companies and organizations buying outsourcing services:"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fifty-three percent reported that they have outsourcing challenges because their companies lack project management skills (i.e., they have no experienced outsourcing governance).")]), _vm._v(" "), _c('li', [_vm._v("Fifty-eight percent reported they lack a good process for specifying the work.")]), _vm._v(" "), _c('li', [_vm._v("Forty-eight percent said they did not have the right metrics for measuring performance.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The most notable trends of the outsourcing phenomenon, as collected by the Global Outsourcing Partnership ("), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.outsourcingpartnership.com",
      "target": "_blank"
    }
  }, [_vm._v("www.outsourcingpartnership.com")])]), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#intro01",
      "id": "dintro01"
    }
  }, [_vm._v("a")])]), _vm._v(") include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Seventeen billion dollars of IT services will go offshore by 2008."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('li', [_vm._v("There are $2.3 million banking jobs to be offshored. Celent says that offshoring has put a potential 2.3 million jobs in the U.S. banking and securities industries at risk. Celent analysts estimate a potential to shift $17.5 billion in operational and technical costs overseas by 2010."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('li', [_vm._v("Eighty percent of U.S. companies will outsource something in 2005. Meta Group predicts that 80 percent of organizations will outsource at least one information technology function by the end of 2005. But the Outsourcing Pricing Guide report also warns that 70 percent of that group will drive a harder bargain when they renew those outsourcing deals, cutting both the scope and duration of the contract."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('li', [_vm._v("Eighty-five percent of current outsourcing contracts to be re-negotiated, Gartner analysts said that 85 percent of all outsourcing contracts signed since 2001 through year-end 2004 will be renegotiated within three years of signing because the original contracts did not serve the enterprise’s long-term objectives."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('li', [_vm._v("Business process outsourcing will grow. A final verdict released by research firm Gartner prophesized that by 2005, the number of enterprises that enter into new outsourcing relationships, will increase 30 percent, while the number of IT providers that claim outsourcing relationships, will grow by 40 percent. Through 2004, despite the potential human resource backlash, 80 percent of U.S. executive boards will have discussed global delivery options, both nearshore and offshore. Out of these enterprises using global delivery models, 80 percent will act by increasing their people resources (nearshore and offshore), by as much as 30 percent.")]), _vm._v(" "), _c('li', [_vm._v("Gartner predicts strong BPO growth in India, both captive as well as outsourced. The current global BPO market stands at $173 billion, which is expected to rise to $27.7 billion by 2007. Indian offshore BPO will grab $13.8 billion from the total, or approximately 49 percent of the pie. The boom is estimated on a Gartner survey, which reveals that 19 percent of companies in the United States are planning to outsource in the next 24 months, as opposed to a meager 1 percent who are currently outsourcing."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('li', [_vm._v("Europeans will outsource $9.6 billion in 2008. The take-up of finance and accounting business process outsourcing services by European firms will nearly double from its present size of $5.1 billion to $9.6 billion by 2008, market watcher IDC has predicted."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('li', [_vm._v("Outsourcing to hit $1.2 trillion by 2007. The outsourcing market, riding a healthy 7 percent annual growth toward an estimated $1.2 trillion in 2007, will be dominated by a few global players in on-demand computing, an industry watcher said at an outsourcing conference in Bangalore."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('li', [_vm._v("By 2015, 3.4 million jobs will move offshore. Forrester Research now says it expects that 830,000 U.S. service jobs will move to low-wage countries such as China, India, and Mexico by the end of 2005. Last year, the firm put that number at 588,000. The new study estimates that 3.4 million jobs will move offshore by 2015, up from 3.3 million predicted last year."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('li', [_vm._v("At least $75 million of U.S. government contracts goes offshore. At least $75 million in U.S. state contract work has been captured by 18 companies that specialize in offshore outsourcing."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('li', [_vm._v("Canada loses IT jobs through offshore outsourcing, gains through U.S. contracts. The report by PricewaterhouseCoopers showed that Canada could lose up to 75,000 IT jobs by 2010 to offshore outsourcing, but Canada could also gain some 165,000 jobs through U.S. outsourcing contracts."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('li', [_vm._v("Financial sector to outsource at 34 percent annually. Outsourcing is on the rise in the financial services industry, according to research firm TowerGroup. The researcher estimates that the top 15 global financial services companies will increase their outsourcing of information technology projects from a value of $1.6 billion this year to $3.89 billion in 2008, an increase of 34 percent annually."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('li', [_vm._v("The U.S. government can outsource 900,000 jobs. The government’s push to open federal jobs to competition could open as much as $70 billion outsourcing opportunities to private firms, but lingering uncertainties on the final version of the rules make it more difficult to predict, according to a new report from research firm Input. Researchers considered the number of jobs that could be outsourced—officials have estimated that almost 900,000 federal jobs could be suitable for outsourcing—and Bush administration officials have said they want agencies to open half of those to competition by September 2004."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('li', [_vm._v("Forty percent of IT businesses have explored outsourcing in 2004. According to analysis from Gartner, by next year more than 40 percent of IT-related businesses will either be investigating the possibility of offshore outsourcing or will have already started projects overseas."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('li', [_vm._v("Manufacturing firms to increase outsourcing by 9.3 percent in 2005. Manufacturing companies are planning for healthy increases in 2005, led by a projected 9.3 percent increase of outsourcing budgets, according to a report from AMR Research. New IT investments are aimed primarily at supporting supply chain transformation and the profitable acquisition of new customers. Respondents estimate that 25 percent of IT work is currently outsourced, and 53 percent intend to increase that amount. The overall increase planned for 2005 is a robust 9.3 percent."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('li', [_vm._v("India to lose outsourcing market share by 2007. India is likely to lose market share in offshore business process outsourcing (BPO), from its current 80 percent to about 55 percent by 2007."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('li', [_vm._v("Only 2.5 percent of U.S. jobs are lost due to outsourcing. Labor Department said moving jobs overseas accounted for about 2.5 percent of the 182,456 workers who lost their jobs for longer than a month for nonseasonal factors in Q1 2004. Moving jobs within the United States accounted for 9,985 layoffs, or 5.5 percent of nonseasonal mass layoffs. About two-thirds of the jobs moved were in the manufacturing sector. Manufacturing accounted for about 25 percent of all mass layoffs. Seventy-six percent of the jobs moved stayed in the same company, although 36 percent of jobs moved overseas were with a different company."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('li', [_vm._v("Financial sector to outsource at 34 percent annually. Outsourcing is on the rise in the financial services industry, according to research firm TowerGroup. The researcher estimates that the top 15 global financial services companies will increase their outsourcing of information technology projects from a value of $1.6 billion this year to $3.89 billion in 2008, an increase of 34 percent annually."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('li', [_vm._v("Deloitte projects that by 2008, 275,000 of the telecom industry’s 5.5 million positions will have been sent overseas. The telecommunications industry is set to save $14.5 billion in the next four years through offshoring 5 percent of its workforce to countries such as India, Estonia, and Argentina."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('li', [_vm._v("Eighty-six percent of U.S. companies will increase offshoring. About 86 percent of U.S. companies plan to increase the use of offshore outsourcing firms, according to a poll by Chicago-based management consulting firm DiamondCluster International. They expect outsourcing to save only 10 percent to 20 percent of their costs, down sharply from 50 percent two years ago. About 85 percent of customers and 81 percent of providers are concerned that legislation or political pressure may prevent them from shifting jobs offshore."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('li', [_vm._v("The next wave of outsourcing will be research and development (R&D) functions, according to the latest Santa Clara University Business Index. The monthly business indicator tracks business conditions and jobs by polling executives and managers in a wide range of companies. While R&D hasn’t been moving offshore at the rate of manufacturing and customer support, SCU finance professor Robert Henderschott told "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://Internetnews.com",
      "target": "_blank"
    }
  }, [_vm._v("Internetnews.com")])]), _vm._v(" says a trend is developing."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en22"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As these numbers indicate, companies that fail to manage their outsourcing relationships will not only spend more money than is necessary, they will also obtain fewer benefits. Customer satisfaction will be impacted, which will increase the risk of outsourcing failure.")]), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "sec94"
    }
  }, [_vm._v("WHAT’S DIFFERENT ABOUT OUTSOURCING")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("To implement outsourcing successfully, it’s first necessary to understand that it is fundamentally different from other recent business trends and, therefore, poses greater risks for industrialized economies. We have to face facts: Most of the white-collar and executive jobs downsized in the last few years in the United States and the United Kingdom are gone forever. And as this “new economy” evolves, the pursuit of the lowest-cost source is going to be happening on a global scale. The old regional trade agreements of the past, like North American Free Trade Agreement (NAFTA), are becoming obsolete. If you doubt this, consider these results of a survey of 20 large European firms: for 75 percent, offshore/near-shore outsourcing spending will increase between now and 2005; and outsourcing’s share of Europe’s IT services spending is expected to grow from 29 percent in 2002 to 43 percent in 2008."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en23"
    }
  }, [_vm._v("23")])]), _vm._v(" From 2004, BPO is expected to grow faster than all other categories of IT services. Demands for technology innovation and best-of-breed transition skills will drive provider choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The hard truth is that the rules that used to guide us in shaping a career, starting a new business, or leading an established company no longer apply. The complexities of outsourcing are forcing drastic managerial and professional career changes, and those professionals who do not update their skill sets to successfully administer outsourcing initiatives will be replaced by those who do.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you still doubt that business process outsourcing is changing the way the world does business, and that this trend is likely to accelerate, these statistics should convince you:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("By 2007, offshore BPO is expected to account for 14 percent of the total BPO market, compared with only 1 percent in 2003."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('li', [_vm._v("Global market for outsourcing is estimated to grow at an annual rate of 7 percent, to 1.2 trillion dollars by 2007."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en25"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Seventy-three percent of U.S. executives interviewed said their companies presently outsource one or more business processes to external service providers. As released by PricewaterhouseCoopers, top U.S. companies are turning to business process outsourcing based on interviews with senior executives at more than 100 U.S. companies averaging about $4.4 billion in yearly revenue.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A PricewaterhouseCoopers Global Top Decision-Makers Study is a landmark study—the first to focus exclusively on BPO at billion-dollar multinationals."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en26"
    }
  }, [_vm._v("26")])]), _vm._v(" Conducted by Yankelovich Partners for PricewaterhouseCoopers, the study provides an in-depth report of the attitudes and behavior of senior executives and their companies toward BPO in general, and Finance & Accounting Services (F&A Services) specifically.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Interviews were conducted with 304 top decision-making executives in 14 countries: CEOs, Presidents, CFOs, COOs and CIOs. Among this group, 192 companies (63 percent) report outsourcing one or more business processes. And, of these companies (41 percent) report outsourcing Finance & Accounting Services which includes General F&A, Internal Audit, and Tax Compliance. Over 300 companies participated in the study—covering the Americas, Europe, Asia Pacific, and South America. The findings of the study reflect an increasing interest in, and usage of, BPO as a strategic initiative:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Business Processes")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Currently Outsourcing (%)")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Best Candidate for BPO (All Companies) (%)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Human resources")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("42")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("59")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Finance and accounting")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("41")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Payroll")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("37")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Real estate")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("32")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("65")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Procurement")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Top executives increasingly recognize the need to manage their company’s growth with less infrastructure. Thus, they are considering outsourcing processes that are essential, but not core to the growth of their business, including Finance & Accounting functions:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Attitudes toward BPO")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Companies Outsourcing Finance and Accounting (%)")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "29%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All Companies (%)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("BPO allows companies to focus on core competencies")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("94")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("86")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("BPO allows companies greater efficiencies without having to invest in people and technology")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("85")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("76")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("BPO helps companies become more profitable, leading to increase in shareholder value")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("77")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("66")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("BPO will lead to better service levels than internal service departments can provide")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("63")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("48")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Satisfaction with BPO")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Companies Outsourcing Finance and Accounting (%)")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All Outsourcers (%)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Satisfied")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("84")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("84")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Dissatisfied")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("More than 8 out of 10 executives (84 percent) outsourcing Finance and Accounting services are satisfied with their initiatives. One third of these executives report that BPO initiatives are in their company’s current business plans:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Top Three Strategic Benefits of BPO")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Companies Outsourcing Finance and Accounting (%)")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All Companies (%)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Maintain competitive edge")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("67")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Focus on company’s core business")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("79")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("75")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Improve service quality")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("77")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("70")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Yankelovich research suggests that the bottom-line benefits of BPO are beginning to be recognized and appreciated. Forward thinking CEOs and CFOs are increasingly utilizing BPO as a new strategic tool to improve their competitive stance, their profitability and ultimately, helping to build shareholder value:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Eighty-four percent of large-company CEOs are satisfied with their outsourcing experience."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('li', [_vm._v("Market perception of outsourcing has shifted from a way for companies to meet short-term financial objectives to a technique for strong companies to improve competitive positions."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en28"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Empowering Executives to Outsource")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Michael F. Corbett & Associates, Ltd. conducted research with more than 500 executives and found that:"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("One in four organizations plan to increase their outsourcing spending by 25 percent or more.")]), _vm._v(" "), _c('li', [_vm._v("Outsourcing will represent 19.5 percent of the typical executive’s budget, up from 16.4 percent today.")]), _vm._v(" "), _c('li', [_vm._v("Firms in dynamic markets such as telecommunications, high-tech products, and professional services, already source more than 40 percent of their operations outside.")]), _vm._v(" "), _c('li', [_vm._v("Innovation is now seen as the key strategic benefit of outsourcing.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The business process outsourcing market continues to show healthy growth despite the economic slowdown. Worldwide, BPO services are predicted to expand by a 9.5 percent compound annual growth rate by 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following illustration compares the Worldwide BPO Market, 1999 versus 2004."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('div', {
    staticClass: "graphics"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since the Industrial Revolution, outsourcing (previously called “sub-contracting”) has helped thousands of companies achieve profitability through increased efficiency. Nearly every U.S. and European company outsources some part of their business—although not even their own employees may realize it. Companies rarely build manufacturing plants in the United States or United Kingdom anymore, for example. Instead, China, Eastern Europe, India, the Philippines, South Korea, and Taiwan are the locations of choice for this purpose. And with the advent of the Internet and satellite and transoceanic communications, businesses require fewer people to do more work; these technologies can also shorten the learning curve for new skills. Perhaps most notable is that specialized tasks such as software development, financial research, and customer service can be accomplished anywhere in the world at a fraction of U.S. or most European labor costs—as much as 30 to 50 percent net.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clearly, then, it is often in a firm’s best interest to outsource certain tasks and use the abilities of its remaining in-house workers in other, more productive activities.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Over the next decade, a fundamental shift will cause the migration of transactional, technology, and administrative processes offshore. In the 1980s, the physical supply chain moved to cheaper locations in the 1980s; in the 1990s, the information supply chain, including IT and software application development and maintenance, moved offshore. Now it’s the administrative supply chain. In the next wave, many knowledge-based positions will likely go offshore, too, including human resources administration, distant medicine, high-level CPAs and accountants, and high-end IT architecture and design engineers.")]), _vm._v(" "), _c('div', {
    staticClass: "feature1"
  }, [_c('div', {
    staticClass: "featurepara"
  }, [_vm._v("My members (Link to ITAA Membership List: "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.itaa.org/about/members.cfm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.itaa.org/about/members.cfm")])]), _vm._v(") believe outsourcing—rather than trying to build and retain a substantial in-house capability—remains the most effective strategy for conducting a wide variety of operations. Outsourcing is not necessarily offshoring. Rather, offshore development and maintenance is a subset of outsourcing. The outsourcing provider may perform services on shore, offshore, or in some combination of the two. The decision is based on a variety of factors, not the least of which is customer preference.")]), _vm._v(" "), _c('div', {
    staticClass: "featuresource"
  }, [_vm._v("—Harris Miller, president of the Information Technology Association of America (ITAA), representing 400 companies involved in every aspect of the IT industry. Source: Senate Democratic Policy Committee Hearing, March 5, 2004.")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "sec95"
    }
  }, [_vm._v("DEBATING THE ISSUE")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("From a purely capitalist perspective, these market forces bring good news. Companies that focus on cost, quality, and performance will be the most competitive and profitable, and will lower the cost of goods and services for people around the world, while raising standards of living in low-wage countries. The bad news is, high-wage countries must face the upheaval caused by the resultant job losses.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("The Dollar Value")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Hard experience has demonstrated that, in procurement alone, outsourcing can help reduce:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Supply and service pricing by 10 to 25 percent through strategic sourcing.")]), _vm._v(" "), _c('li', [_vm._v("Administrative costs by 50 to 75 percent.")]), _vm._v(" "), _c('li', [_vm._v("Consumption and spending by 10 to 20 percent.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On the human resources side, outsourcing has the potential to drive HR-to-employee ratios to anywhere from 1:500 to 1:200, and help reduce overall customer care agent costs by as much as 25 percent."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As we’ve said, in the United Kingdom and across Europe, many workers have lost their jobs, and more layoffs are announced every day, the consequence of outsourcing. In the United States, according to Forrester Research, the total number of jobs lost to outsourcing overseas will reach 791,000 by 2010, and 3,300,000 by 2015."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en32"
    }
  }, [_vm._v("32")])]), _vm._v(" Chances are, you or someone you know has been affected by outsourcing, in one of the areas listed below:"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fm2_en33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('div', {
    staticClass: "graphics"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Critics of outsourcing accuse businesspeople of being unconcerned or indifferent to the working and middle classes of developed countries, including those in the United States and the United Kingdom, the two countries most affected by the shift in jobs overseas. The resultant hullabaloo has alternately infuriated, confused, and shamed some business leaders to the point at which they have chosen to avoid sensible, progressive outsourcing in their organizations. Unemployed workers likewise are furious and confused. Both groups need to educate themselves about the opportunities created by outsourcing. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Book of Outsourcing")]), _vm._v(" will help launch that effort.")]), _vm._v(" "), _c('div', {
    staticClass: "feature1"
  }, [_c('div', {
    staticClass: "featuretitle"
  }, [_vm._v("INSOURCING: THE OTHER SIDE OF THE COIN")]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("As the avalanche of work from the United States, United Kingdom, and Europe continues to flow toward foreign shores, some analysts are watching a trickle of jobs starting to move back in the direction of their source.")]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("These analysts are starting to speculate if these incoming jobs actually could help compensate for the high-paying, high-tech jobs that are being offshored, leaving behind a troubled white-collar workforce and a diminished technology industry.")]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("“Outsourcing has crowded out the globalization topic,” says Matthew Slaughter, associate professor of business at Dartmouth College’s Tuck School of Business. “It is important to understand the contribution of these [foreign] companies to the U.S. economy.”")]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("Slaughter recently released a study, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Insourcing Jobs: Making the Global Economy Work for America,")]), _vm._v(" which describes the impact of foreign companies hiring workers here in the United States—in all industries, including IT. It also states that these companies employ nearly five percent of those working in the private sector and have paid American workers $307 billion."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#aint01",
      "id": "int01"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("Many people in this country are unaware that offshore companies also are sending jobs "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to")]), _vm._v(" the United States and Great Britain, and have been for decades. Job losses from offshore outsourcing are, to some degree, offset by insourcing. And according to Matthew Slaughter, insourcing activity has been increasing steadily over the last decade."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#aint02",
      "id": "int02"
    }
  }, [_vm._v("b")])]), _vm._v(" Slaughter says, “Over the past generation the number of U.S. jobs at these subsidiaries has more than doubled.” Slaughter also notes that insourcing companies also contribute to U.S. economic growth by spurring investments in research and development, physical capital, and international trade. Moreover, insourcing companies pay better than their domestic competitors, Slaughter found.")]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("Several statistics highlight the importance of insourcing. U.S. subsidiaries of foreign companies employ more than 5.4 million U.S. workers—roughly 5 percent of overall private sector employment, an increase from 3 percent in 1987. As for research and development, insourcing companies now account for a sizeable share—nearly 15 percent, or $27.5 billion—of private sector R&D activity in the United States, up from 9 percent in 1992. Similarly, U.S. subsidiaries of foreign companies accounted for 10 percent ($111.9 billion) of private sector capital investments, up from 8 percent in 1992. Most surprising is that insourcing companies also account for a sizeable share (20 percent, $137 billion) of U.S. exports. And on the payroll front, subsidiaries of foreign companies paid U.S. workers more than $307 billion—6 percent more than overall U.S. private sector labor compensation. The average annual compensation at insourcing companies was $56,667—nearly one-third more than in the nonsubsidiary U.S. private sector. This tally has increased sharply from 20 percent in 1992.")]), _vm._v(" "), _c('div', {
    staticClass: "featurepara"
  }, [_vm._v("According to Slaughter, insourcing helps the U.S. economy in other ways as well. “The other channel by which insourcing companies contribute to the U.S. economy is their interactions with other domestic U.S. firms.” For starters, insourcing companies typically purchase a majority of their supplies from domestic firms—to the tune of 80 cents out of every dollar, or $1.26 trillion.")]), _vm._v(" "), _c('div', {
    staticClass: "featurefootnote"
  }, [_c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#int01",
      "id": "aint01"
    }
  }, [_vm._v("a")])]), _vm._v(" “Insourcing Jobs: Making the Global Economy Work for America,” study sponsored by the Organization for International Investment, 2004; available online at "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ofii.org/disputes",
      "target": "_blank"
    }
  }, [_vm._v("www.ofii.org/disputes")])]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "featurefootnote"
  }, [_c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#int02",
      "id": "aint02"
    }
  }, [_vm._v("b")])]), _vm._v(" Matthew Slaughter, author of the report in note a named above, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ofii.org/insourcing/insourcing_study.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.ofii.org/insourcing/insourcing_study.pdf")])]), _vm._v("; Professor Matthew J. Slaughter, Insourcing Jobs: Making the Global Economy Work for America; November 2004 also Citation: Matthew Slaughter. Enterprise Systems Journals, full article at "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.esj.com/enterprise/article.aspx?EditorialsID=1170",
      "target": "_blank"
    }
  }, [_vm._v("http://www.esj.com/enterprise/article.aspx?EditorialsID=1170")])]), _vm._v(" (Stephen Swoyer, Outsourcing in Reverse: Foreign Companies Send Jobs to the United States: Not all outsourcing activity is a net loss for American workers, October 26, 2004).")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "sec96"
    }
  }, [_vm._v("WHO THIS BOOK IS FOR")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("This book has been written for the three largest groups of individuals affected by outsourcing:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Corporate managers buying and leading outsourcing services.")]), _vm._v(" If you fall into this category, you will learn what is necessary to manage a successful outsourcing initiative at your “buyer” business and how to work with outsourcing vendors.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Job seekers (particularly those displaced by outsourcing).")]), _vm._v(" You will learn how to launch a new career and find a job in the new global economy.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outsourcing entrepreneurs.")]), _vm._v(" Ambitious start-up business owners will learn the basics of establishing your own outsourcing firm (increasingly known as “outventures”).")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Book of Outsourcing")]), _vm._v(" addresses the needs of each of these groups, while diffusing the debates and disputes that turn up the heat on outsourcing discussions. We help you focus on industry-specific situations and challenges. We help buyers, vendors, and entrepreneurs manage the problems they encounter daily, buoyed by sound outsourcing management principles, inspiration to succeed, and innovative solutions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At the heart of this book are the processes that we recommend you follow to conduct your outsourcing program successfully. We’ve developed these proven approaches in our role as consultants to Fortune 500 companies as well as to one-person outventuring start-ups. We’ve seen these success factors work again and again; and in this book we’ll share with you how you can customize these approaches to fit your situation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We’re almost ready to get started now, but before you read on, take the time to make a list of your goals, and keep them in mind as we proceed. Your list might include how to:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Use outsourcing to meet today’s business challenges.")]), _vm._v(" "), _c('li', [_vm._v("Make the right sourcing decisions—the first time.")]), _vm._v(" "), _c('li', [_vm._v("Achieve operational excellence within and across outsourcing relationships.")]), _vm._v(" "), _c('li', [_vm._v("Communicate outsourcing to your employees, customers, and the public.")]), _vm._v(" "), _c('li', [_vm._v("Build new revenue streams through outsourcing.")]), _vm._v(" "), _c('li', [_vm._v("Use outsourcing to reduce corporate risk.")]), _vm._v(" "), _c('li', [_vm._v("Successfully outsource offshore.")]), _vm._v(" "), _c('li', [_vm._v("Craft value-creating outsourcing contracts.")]), _vm._v(" "), _c('li', [_vm._v("Recover from a troubled outsourcing relationship.")]), _vm._v(" "), _c('li', [_vm._v("Enhance your career as an outsourcing professional.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Until now, pro-outsourcing zealots have neglected to mention why outsourcing deals fail, the occasionally staggering costs of attorneys versed in international contracts, the cross-infrastructure problems including cultural clashes, the widespread corruption in many foreign governments, and other factors that wipe out the wage savings involved in outsourcing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We recommend that you do a little research and you’ll find out that one in three outsourcing projects fail because most are not heading into outsourcing initiatives with their eyes open or their staffs informed. Many outsourcing decision makers also do not—or can not—afford the detailed analysis that can only be found in expensive research reports from the big-name analyst firms.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whatever your goals, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Black Book of Outsourcing")]), _vm._v(" is sure to help you meet them. Now let’s get started.")]), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "sec97"
    }
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en1"
    }
  }, [_vm._v("1")]), _vm._v(". 2004 Economic Report of the President, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cbsnews.com/stories/2004/02/13/national/main600034.shtml",
      "target": "_blank"
    }
  }, [_vm._v("http://www.cbsnews.com/stories/2004/02/13/national/main600034.shtml")])]), _vm._v(", February 13, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en2"
    }
  }, [_vm._v("2")]), _vm._v(". Julie Giera, “Outsourcing Management: Align Management Techniques to the Outsourcing Model IT View and Business View Planning Assumption,” September 30, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.forrester.com/Cart?addDocs=32555",
      "target": "_blank"
    }
  }, [_vm._v("www.forrester.com/Cart?addDocs=32555")])]), _vm._v(". Three Forrester reports were used to compile this information: the above mentioned report and Stephanie Moore, William Martorelli, Adam Brown, “Midyear 2004 Update: North American Offshore Outsourcing” July 14, 2004, also Stephanie Moore, “IT Trends 2004: Offshore Outsourcing,” December 17, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en3"
    }
  }, [_vm._v("3")]), _vm._v(". IDC, Inc., News Release, October 25, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.idc.com/research/reshome.jsp",
      "target": "_blank"
    }
  }, [_vm._v("http://www.idc.com/research/reshome.jsp")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en4"
    }
  }, [_vm._v("4")]), _vm._v(". Celent, July 15, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.industryanalystreporter.com/T2/Analyst_Research/ResearchAnnouncementsDetails.asp?Newsid=3080",
      "target": "_blank"
    }
  }, [_vm._v("http://www.industryanalystreporter.com/T2/Analyst_Research/ResearchAnnouncementsDetails.asp?Newsid=3080")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en5"
    }
  }, [_vm._v("5")]), _vm._v(". Cnet Tech News, August 11, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://news.com.com/Outsourcing+to+rise%2C+but+deals+to+shrink/2100-1011_3-5305640.html?part=rss&tag=5305640&subj=news.1011.20",
      "target": "_blank"
    }
  }, [_vm._v("http://news.com.com/Outsourcing+to+rise%2C+but+deals+to+shrink/2100-1011_3-5305640.html?part=rss&tag=5305640&subj=news.1011.20")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en6"
    }
  }, [_vm._v("6")]), _vm._v(". November 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tekrati.com/T2/Analyst_Research/ResearchAnnouncementsDetails.asp?Newsid=2541",
      "target": "_blank"
    }
  }, [_vm._v("http://www.tekrati.com/T2/Analyst_Research/ResearchAnnouncementsDetails.asp?Newsid=2541")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en7"
    }
  }, [_vm._v("7")]), _vm._v(". December 4, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cxotoday.com/cxo/jsp/article.jsp?article_id?401&cat_id=908&source=null",
      "target": "_blank"
    }
  }, [_vm._v("http://www.cxotoday.com/cxo/jsp/article.jsp?article_id?401&cat_id=908&source=null")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en8"
    }
  }, [_vm._v("8")]), _vm._v(". March 4, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.vnunet.com/news/1153208",
      "target": "_blank"
    }
  }, [_vm._v("http://www.vnunet.com/news/1153208")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en9"
    }
  }, [_vm._v("9")]), _vm._v(". Cnet, November 5, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://news.zdnet.com/2110-3513_22-5102508.html",
      "target": "_blank"
    }
  }, [_vm._v("http://news.zdnet.com/2110-3513_22-5102508.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en10"
    }
  }, [_vm._v("10")]), _vm._v(". InfoWeek, May 24, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.informationweek.com/story/showArticle.jhtml?articleID=20900333",
      "target": "_blank"
    }
  }, [_vm._v("http://www.informationweek.com/story/showArticle.jhtml?articleID=20900333")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en11"
    }
  }, [_vm._v("11")]), _vm._v(". WashTech, Cnet Tech News, July 14, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://news.com.com/Study%3A+States+doing+plenty+of+offshoring/2100-1022_3-5269261.html?part=rss&tag=5269261&subj=news.1022.5",
      "target": "_blank"
    }
  }, [_vm._v("http://news.com.com/Study%3A+States+doing+plenty+of+offshoring/2100-1022_3-5269261.html?part=rss&tag=5269261&subj=news.1022.5")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("IT Managers Journal,")]), _vm._v(" July 15, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en13"
    }
  }, [_vm._v("13")]), _vm._v(". Cnet, April 4, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://news.com.com/2110-7343_3-5191655.html?part=rss&tag=feed&subj=news",
      "target": "_blank"
    }
  }, [_vm._v("http://news.com.com/2110-7343_3-5191655.html?part=rss&tag=feed&subj=news")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en14"
    }
  }, [_vm._v("14")]), _vm._v(". Federal Computer Week, December 18, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fcw.com/fcw/articles/2003/1215/web-outsource-12-18-03.asp",
      "target": "_blank"
    }
  }, [_vm._v("http://www.fcw.com/fcw/articles/2003/1215/web-outsource-12-18-03.asp")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en15"
    }
  }, [_vm._v("15")]), _vm._v(". PR Newswire, December 18, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.prnewswire.com/cgi-bin/stories.pl?ACCT=SVBIZINK3.story&STORY=/www/story/12-18-2003/0002078000&EDATE=THU+Dec+18+2003,+09:02+AM",
      "target": "_blank"
    }
  }, [_vm._v("http://www.prnewswire.com/cgi-bin/stories.pl?ACCT=SVBIZINK3.story&STORY=/www/story/12-18-2003/0002078000&EDATE=THU+Dec+18+2003,+09:02+AM")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en16"
    }
  }, [_vm._v("16")]), _vm._v(". TechWeb, October 1, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.techweb.com/wire/ebiz/49400123",
      "target": "_blank"
    }
  }, [_vm._v("http://www.techweb.com/wire/ebiz/49400123")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en17"
    }
  }, [_vm._v("17")]), _vm._v(". Gartner Inc., InfoWorld, August 30, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.infoworld.com/article/04/08/30/HNindiabpo_1.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.infoworld.com/article/04/08/30/HNindiabpo_1.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en18"
    }
  }, [_vm._v("18")]), _vm._v(". CBS Marketwatch, June 10, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.marketwatch.com/news/yahoo/story.asp?guid=%7B65859158-B0EA-4852-B7C2-AF68657E0F8%7D&siteid=myyahoo&dist=myyahoo",
      "target": "_blank"
    }
  }, [_vm._v("http://www.marketwatch.com/news/yahoo/story.asp?guid=%7B65859158-B0EA-4852-B7C2-AF68657E0F8%7D&siteid=myyahoo&dist=myyahoo")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en19"
    }
  }, [_vm._v("19")]), _vm._v(". OutsourcingCnet, April 14, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://news.com.com/2110-7343_3-5191655.html?part=rss&tag=feed&subj=news",
      "target": "_blank"
    }
  }, [_vm._v("http://news.com.com/2110-7343_3-5191655.html?part=rss&tag=feed&subj=news")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en20"
    }
  }, [_vm._v("20")]), _vm._v(". Deloitte and Touche survey, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("InfoWorld,")]), _vm._v(" March 29, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.infoworld.com/article/04/03/29/HNtelcooffshore_1.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.infoworld.com/article/04/03/29/HNtelcooffshore_1.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en21"
    }
  }, [_vm._v("21")]), _vm._v(". DiamondCluster International, release March 26, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en22"
    }
  }, [_vm._v("22")]), _vm._v(". Silicon Valley News, August 28, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://siliconvalley.internet.com/news/article.php/3069991",
      "target": "_blank"
    }
  }, [_vm._v("http://siliconvalley.internet.com/news/article.php/3069991")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en23"
    }
  }, [_vm._v("23")]), _vm._v(". Manuel Ángel Méndez, with David Metcalfe and Andrew Parker, “Analyzing Europe’s BPO Growth Explosion,” second in Forrester Research’s European IT Services Spending series, December 11, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en24"
    }
  }, [_vm._v("24")]), _vm._v(". Linda R. Cohen, Lorrie Scardino, and Lisa Stone, Gartner Research: Predictions for Outsourcing in 2004, December 11, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en25"
    }
  }, [_vm._v("25")]), _vm._v(". IDC, Inc., News Release, October 25, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.idc.com/research/reshome.jsp",
      "target": "_blank"
    }
  }, [_vm._v("http://www.idc.com/research/reshome.jsp")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en26"
    }
  }, [_vm._v("26")]), _vm._v(". PricewaterhouseCoopers, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.coltexpress.com/files/Business_Process_Outsourcing.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.coltexpress.com/files/Business_Process_Outsourcing.pdf")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en27"
    }
  }, [_vm._v("27")]), _vm._v(". Yankelovich Partners, Global Top Decision-Makers Study on Business Process Outsourcing, sponsored by PricewaterhouseCoopers, 1999–2001.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en28"
    }
  }, [_vm._v("28")]), _vm._v(". See note 24.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en29"
    }
  }, [_vm._v("29")]), _vm._v(". Rebecca S. Scholl, Cathy Tornbohm, Ravi Datar, Rika Narisawa, Kathryn Hale, and Robert De Souza, “Market to Grow to $173 Billion in 2007,” Executive Summary, Gartner Research, July 7, 2003, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gartner.com/DisplayDocument?doc_cd=116058",
      "target": "_blank"
    }
  }, [_vm._v("http://www.gartner.com/DisplayDocument?doc_cd=116058")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en30"
    }
  }, [_vm._v("30")]), _vm._v(". Gartner Dataquest.")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en31"
    }
  }, [_vm._v("31")]), _vm._v(". Anthony R. Roma, Partner, “Achieving Business Transformation through Outsourcing,” 2004, IBM Business Transformation Outsourcing Financial Services, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www-1.ibm.com/industries/financialservices/doc/content/landing/895386103.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www-1.ibm.com/industries/financialservices/doc/content/landing/895386103.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en32"
    }
  }, [_vm._v("32")]), _vm._v(". Bureau of Labor Statistics; Forrester Research Inc. Chronicle Graphic, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://sfgate.com/cgi-bin/article.cgi?file=/c/a/2004/05/18/BUGQ26ND7B1.DTL&type=printable",
      "target": "_blank"
    }
  }, [_vm._v("http://sfgate.com/cgi-bin/article.cgi?file=/c/a/2004/05/18/BUGQ26ND7B1.DTL&type=printable")])]), _vm._v("; “The Effect of Outsourcing and Offshoring on BLS Productivity Measures,” March 26, 2004, "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bls.gov/lpc/lproffshoring.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.bls.gov/lpc/lproffshoring.pdf")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "endnoteentry"
  }, [_c('a', {
    attrs: {
      "id": "fm2en33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2_en33"
    }
  }, [_vm._v("33")]), _vm._v(". Andrew Parker with David Metcalfe and Sonoko Takahash, “Two-Speed Europe: Why 1 Million Jobs Will Move Offshore, Forrester Research,” August 18, 2004; and John C. McCarthy with Amy Dash, Heather Liddell, Christine Ferrusi Ross, and Bruce D. Temkin, “3.3 Million U.S. Services Jobs to Go Offshore,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("IT View and Business View Brief,")]), _vm._v(" Forrester Research, November 11, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Note:")]), _vm._v(" Web addresses flagged with a ("), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#dintro01",
      "id": "intro01"
    }
  }, [_vm._v("a")])]), _vm._v(") are author affiliated sites.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89f68186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Introduction.vue
// module id = 72
// module chunks = 0